import React from 'react';

import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export function Warning() {
  return (
    <Alert bsStyle="warning" className="royalty-schedule-warning">
      <div>
        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} size="lg" />
      </div>
      <div>The royalty schedule has already been used for payments and some of the information cannot be edited.</div>
    </Alert>
  );
}

export default Warning;
